import envDetect from '@tcc/env-detect';

/**
 *  Mockable wrapper for envDetect
 * @returns {String} current Environment
 */
export function getCurrentEnv() {
  return envDetect.getCurrentEnv();
}